<dx-popup
  [showTitle]="true"
  title="Supprimer les lots périmés du stock"
  [(visible)]="displayDialog"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHiding)="closeDialog()"
  (onDisposing)="closeDialog()"
  width="800"
>
  <div class="dialog-line">
    <div class="label" title="LotsPerimes">Supprimer les lots périmés avant le :</div>
    <div class="value">
      <dx-date-box [value]="dateSelected" type="date" (onValueChanged)="changeDateSelected($event)"></dx-date-box>
    </div>
  </div>

  <div class="dialog-line">
    <div class="label" title="SelectionUdp">Sur les unités de production suivantes :</div>
    <div class="value">
      <yo-tagbox
        [data]="udpList"
        (onValueChange)="onSelectionChange($event)"
        [selectedItems]="udpSelected"
        [placeholder]="'Sélectionner les unités de production...'"
      >
      </yo-tagbox>
    </div>
  </div>

  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        iconClass="fas fa-trash"
        [theme]="ButtonThemeEnum.DELETE_INNER"
        (onClick)="deletePerimes()"
        [disabled]="!canDelete()"
        tooltip="Supprimer les lots périmés">
      </yo-button>
      <yo-button
        buttonClass="cta-inner-delete"
        [theme]="ButtonThemeEnum.DELETE_INNER"
        (onClick)="closeDialog()"
        label="Annuler">
      </yo-button>
    </div>
  </div>
</dx-popup>

